class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('sticky-header');
    this.headerWrapper = document
      .querySelector('.shopify-section-group-header-group ')
      .querySelector('.js-header-wrapper');
    this.cartFlyoutOverlay = document.querySelector('.js-cart__flyout-overlay');
    this.cartFlyoutContainer = document.querySelector(
      '.js-cart__flyout-container'
    );
    this.cartLineItemsContainer = document.querySelector(
      '.js-cart-flyout__line-items-container '
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.checkoutButton = document.querySelector(
      '.js-cart-flyout__footer-checkout-btn'
    );

    this.isTokenGated = this.dataset.istokengated;
    this.cartIcon = document.querySelector('#cart-icon-bubble');
    this.addEventListeners();
  }

  open() {
    this.toggleCartFlyout();
    this.headerWrapper.classList.add('with-cart-flyout');
    this.cartFlyoutOverlay.classList.add('is-open');
    document.body.addEventListener('click', this.onBodyClick);
    window.trapFocus(this.cartFlyoutContainer); // Apply focus trap when cart is opened
  }

  addEventListeners() {
    // Keydown event to support Enter and Space for keyboard interaction
    this.cartIcon.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevent default behavior for Space
        this.toggleCartFlyout();
        window.trapFocus(this.cartFlyoutContainer); // Apply focus trap when cart is opened
      }
    });

    // Optional: Handle Esc key to close the cart if it's open
    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        this.cartFlyoutContainer.classList.contains('is-open')
      ) {
        this.close();
        this.cartIcon.focus(); // Return focus to the cart icon when closed
      }
    });
  }

  close() {
    this.toggleCartFlyout();
    this.headerWrapper.classList.remove('with-cart-flyout');
    this.cartFlyoutOverlay.classList.remove('is-open');
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const cartItems = window.cartItems;
    window.localStorage.setItem('cartItemCount', `${cartItems.item_count}`);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document
          .getElementById('main-cart-items-flyout')
          .querySelector(section.selector) ||
        document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (parsedState.item_count === 0) {
      if (this.cartLineItemsContainer) {
        this.cartLineItemsContainer.classList.add('is-empty');
      }
    } else {
      if (this.cartLineItemsContainer) {
        this.cartLineItemsContainer.classList.remove('is-empty');
      }
    }

    if (cartItems.items.length > 0) {
      cartItems.items.find((item) => {
        if (
          item.properties != null &&
          Object.keys(item.properties).length > 0 &&
          this.isTokenGated == 'true'
        ) {
          return;
        }
      });
    }

    const overlay = document.querySelector('.cart-flyout-overlay');

    if (!overlay.classList.contains('is-open')) {
      const emptyCartProductsRecommendations = document.querySelector(
        "[data-js-element='empty-product-recommendations__container']"
      );

      const cartFlyoutRecommendations = document.querySelector(
        '.js-cart-flyout__product-recommendations-ct'
      );

      const cartProductsRecommendations = document.querySelector(
        '.js-cart-recommendations'
      );

      if (!emptyCartProductsRecommendations && !cartFlyoutRecommendations) {
        return;
      }

      cartFlyoutRecommendations.classList.remove('hidden');
      emptyCartProductsRecommendations.classList.add('hidden');

      const product = parsedState;

      if (!product) {
        return;
      }

      fetch(
        window.Shopify.routes.root +
          `recommendations/products?product_id=${product.product_id}&limit=4&section_id=cart-flyout&intent=related`
      )
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          const quickAdds = Array.from(html.querySelectorAll('.quick-add'));
          const quickAddColors = Array.from(
            html.querySelectorAll('.quick-add_colors')
          );

          if (quickAdds.length > 0) {
            quickAdds.forEach((el) => {
              el.classList.add('hidden');
            });
          }

          if (quickAddColors.length > 0) {
            quickAddColors.forEach((el) => {
              el.classList.add('hidden');
            });
          }

          if (recommendations && recommendations.innerHTML.trim().length) {
            cartProductsRecommendations.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            cartProductsRecommendations.classList.add(
              'product-recommendations--loaded'
            );
          }
        })
        .catch((e) => {
          console.error(e);
        });

      this.open();
    }
  }

  renderContentsLocalization(parsedState) {
    this.cartItemKey = parsedState.key;
    const cartItems = window.cartItems;
    window.localStorage.setItem('cartItemCount', `${cartItems.item_count}`);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document
          .getElementById('main-cart-items-flyout')
          .querySelector(section.selector) ||
        document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (parsedState.item_count === 0) {
      if (this.cartLineItemsContainer) {
        this.cartLineItemsContainer.classList.add('is-empty');
      }
    } else {
      if (this.cartLineItemsContainer) {
        this.cartLineItemsContainer.classList.remove('is-empty');
      }
    }

    if (cartItems.items.length > 0) {
      cartItems.items.find((item) => {
        if (
          item.properties != null &&
          Object.keys(item.properties).length > 0 &&
          this.isTokenGated == 'true'
        ) {
          return;
        }
      });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-flyout',
        section: document.getElementById('main-cart-items-flyout'),
        selector: '.js-flyout-contents',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('js-cart__flyout-toggle')) {
      this.close();
    }
  }

  toggleCartFlyout() {
    if (this.cartFlyoutContainer.classList.contains('is-open')) {
      this.cartFlyoutContainer.classList.remove('is-open');
    } else {
      this.cartFlyoutContainer.classList.add('is-open');
    }
  }
}

customElements.define('cart-notification', CartNotification);
